import { dataTrendMonitor } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendMonitor = /*#__PURE__*/createIcon(dataTrendMonitor)
export default IconTrendMonitor
